<template>
  <div>
    <div class="container-fluid">
      <div class="card-body p-4">
        <div class="table-responsive w-100 mt-2">
          <div class="d-flex align-items-center mb-3">
            <h3 style="display: inline; margin-right: 15px">Artículos</h3>
            <AddArticle :tags="tags" :categories="categories" />
          </div>
          
          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <div class="mt-2">Cargando artículos...</div>
            </div>

            <template v-else>
              <table class="table table-bordered settings-table mt-3">
                <thead>
                  <tr class="">
                    <th>Título</th>
                    <th>Categoría</th>
                    <th>Temáticas</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in articles" :key="item.UUID" class="align-middle">
                    <ArticleRow :article="item" :tags="tags" :categories="categories"></ArticleRow>
                  </tr>
                </tbody>
              </table>

              <div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
                <div class="text-muted small">
                  Mostrando 
                  {{ (serverOptions.page - 1) * serverOptions.rowsPerPage + 1 }} - 
                  {{ Math.min(serverOptions.page * serverOptions.rowsPerPage, serverItemsLength) }} 
                  de {{ serverItemsLength }} artículos
                </div>
                <div class="d-flex align-items-center gap-3 small">
                  <span>líneas por página:</span>
                  <select v-model.number="serverOptions.rowsPerPage" @change="updateRowsPerPage" class="form-select form-select-sm w-auto">
                    <option v-for="n in [10, 25, 50]" :key="n" :value="n">{{ n }}</option>
                  </select>
                  <button class="btn btn-sm btn-light" :disabled="serverOptions.page === 1" @click="changePage(serverOptions.page - 1)">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <button class="btn btn-sm btn-light" :disabled="serverOptions.page * serverOptions.rowsPerPage >= serverItemsLength" @click="changePage(serverOptions.page + 1)">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddArticle from "@/components/Blog/elements/Articles/AddArticle.vue";
import ArticleRow from "@/components/Blog/elements/Articles/ArticleRow.vue";
import ArticleService from "@/services/article.service.js";
import CategoryService from "@/services/category.service";

export default {
  name: "Conversations",
  components: {
    AddArticle,
    ArticleRow,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      articles: [],
      tags: [],
      categories: [],
      loading: true,
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 10,
      },
    };
  },
  methods: {
    async getArticles() {
      this.loading = true;
      try {
        const params = {
          page: this.serverOptions.page,
          page_size: this.serverOptions.rowsPerPage
        };
        const response = await ArticleService.getAllArticles(params);
        this.articles = response.data.items;
        this.serverItemsLength = response.data.serverItemsLength;
      } catch (error) {
        console.error("Error al cargar artículos:", error);
      } finally {
        this.loading = false;
      }
    },
    async getCategories() {
      const response = await CategoryService.getAllCategories();
      this.categories = response.data;
    },
    async changePage(newPage) {
      this.serverOptions.page = newPage;
      await this.getArticles();
    },
    async updateRowsPerPage() {
      this.serverOptions.page = 1;
      await this.getArticles();
    }
  },
  created() {
    this.getArticles();
    this.getCategories();
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  },
};
</script>
